
import { Add, Remove } from '@mui/icons-material';
import { FormControl, Grid, IconButton, Slider, TextField } from '@mui/material';
import Typography from '@mui/material/Typography';
import { useEffect, useState } from 'react';
import { useActividadesContext } from '../../UmmIACategories/Hook/useActividades';

const TiempoDedicacionTarea = () => {
    const { promptData, setPromptData } = useActividadesContext();
    const [tiempo, setTiempo] = useState(promptData.tiempo || 10);

    useEffect(() => {
        setPromptData((prevData) => ({
            ...prevData,
            tiempo: tiempo,
        }));
    }, [tiempo, setPromptData]);

    const handleSliderChange = (event, newValue) => {
        setTiempo(newValue);
    };

    const handleInputChange = (event) => {
        const newValue = event.target.value === '' ? '' : Number(event.target.value);
        setTiempo(newValue);
    };

    const handleIncrement = () => {
        setTiempo((prev) => Math.min(prev + 10, 120));
    };

    const handleDecrement = () => {
        setTiempo((prev) => Math.max(prev - 10, 10));
    };

    return (
        <Grid sx={{ mb: 3 }}>
            <FormControl component="fieldset">
                <Typography sx={{ fontFamily: 'Inter', fontSize: '1.25rem', fontWeight: 'bold', mb: 5, color: '#336B87' }}>
                    Cantidad de tiempo aproximado que los estudiantes deben dedicar en total a tarea

                </Typography>
                <Grid container alignItems="center" justifyContent="space-between" spacing={2}>

                    <Grid item xs={8}>
                        <Slider
                            value={typeof tiempo === 'number' ? tiempo : 0}
                            onChange={handleSliderChange}
                            step={10}
                            min={10}
                            max={120}
                            valueLabelDisplay="auto"
                            valueLabelFormat={(value) => `${value} minutos.`}
                            aria-labelledby="tiempo-slider"
                            sx={{
                                color: '#336B87',
                                '& .MuiSlider-markLabel': {
                                    color: '#336B87',
                                    fontFamily: 'montserrat',
                                },
                                '& .MuiSlider-valueLabel': {
                                    backgroundColor: '#F9DA96',
                                    color: '#209099',
                                    fontFamily: 'montserrat'
                                },
                            }}
                        />
                    </Grid>
                    <Grid item xs={4} container spacing={1}>
                        <Grid item>
                            <IconButton onClick={handleDecrement} disabled={tiempo <= 10}>
                                <Remove />
                            </IconButton>
                        </Grid>
                        <Grid item>
                            <TextField
                                variant="standard"
                                value={tiempo}
                                onChange={handleInputChange}
                                inputProps={{
                                    step: 1,
                                    min: 4,
                                    max: 99,
                                    type: 'text',
                                    fontFamily: 'montserrat',
                                    color: '#336B87',
                                    sx: { fontFamily: 'montserrat', color: '#336B87', textAlign: 'center' }
                                }}
                                sx={{ width: 40, textAlign: 'center', fontFamily: 'montserrat', color: '#336B87' }}
                            />
                        </Grid>

                        <Grid item>
                            <IconButton onClick={handleIncrement} disabled={tiempo >= 120}>
                                <Add />
                            </IconButton>
                        </Grid>
                    </Grid>
                </Grid>
            </FormControl>
        </Grid>
    );
};

export default TiempoDedicacionTarea;
